import { filesize } from 'filesize';

const BYTES_TO_MB = 1024 * 1024;

export const toMB = (bytes: number) => bytes / BYTES_TO_MB;

export const fromBytes = (bytes: number) => filesize(bytes, { base: 2 });
